"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSnackbarContentUtilityClass = getSnackbarContentUtilityClass;
var _utils = require("@mui/utils");
var _generateUtilityClass = _interopRequireDefault(require("../generateUtilityClass"));
function getSnackbarContentUtilityClass(slot) {
  return (0, _generateUtilityClass.default)('MuiSnackbarContent', slot);
}
const snackbarContentClasses = (0, _utils.unstable_generateUtilityClasses)('MuiSnackbarContent', ['root', 'message', 'action']);
var _default = exports.default = snackbarContentClasses;